import { render, staticRenderFns } from "./WaterMark.vue?vue&type=template&id=1aecae09&scoped=true"
var script = {}
import style0 from "./WaterMark.vue?vue&type=style&index=0&id=1aecae09&prod&scoped=true&lang=css"
import style1 from "./WaterMark.vue?vue&type=style&index=1&id=1aecae09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aecae09",
  null
  
)

export default component.exports